import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/@mui/material/esm/CircularProgress/CircularProgress.js");
